/* Evolution Motorcycle: "Il mio garage".
   Index (public, no prices) is served by https://evolution-moto-garage.kitchenprotocol.workers.dev/v1/
   built and accuracy-tested by apps/moto-catalog/garage/run_all.sh. Saved bikes live in localStorage
   ("moto-garage") and, for logged-in customers, on the same Worker (/v2/garage). Results always come from the index: a part is shown only if its supplier/title data lists
   that make, model, year (and version when the index says the version matters). */
(function () {
  'use strict';
  if (window.MotoGarage) return;
  var BASE = 'https://evolution-moto-garage.kitchenprotocol.workers.dev/v1/';
  // Storefront root for the current language ("/" or "/en/"), so internal links keep the visitor's language.
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var KEY = 'moto-bike';
  // Brand logos on the garage Worker (logos/<slug>.webp, 300x180, optically balanced); other makes show their initial.
  var LOGOS = ["adly", "aeon", "ajp", "alfer", "aprilia", "arctic-cat", "armstrong", "askoll", "aspes", "atala", "atk", "barigo", "barossa", "batavus", "benelli", "beta", "bimota", "blata", "bmw", "bombardier", "borile", "brixton", "buell", "bullit", "bultaco", "cagiva", "can-am", "cannondale", "ccm", "cectek", "cfmoto", "cobra", "cpi", "cz", "daelim", "daytona", "derbi", "ducati", "e-ton", "energica", "fantic", "fb-mondial", "garelli", "gasgas", "gilera", "gogoro", "harley-davidson", "hercules", "highland", "hm", "honda", "horex", "hrd", "husaberg", "husqvarna", "hyosung", "indian", "innocenti", "italjet", "jawa", "jcm", "jincheng", "john-deere", "jotagas", "kawasaki", "keeway", "kl", "kove", "kram-it", "kreidler", "ktm", "kymco", "laverda", "lem", "linhai", "lml", "loncin", "macbor", "maico", "malaguti", "malanca", "mash", "mbk", "megelli", "minarelli", "montesa", "moriwaki", "moto-guzzi", "moto-morini", "motobecane", "motor-hispania", "mv-agusta", "mz", "niu", "norton", "ohvale", "orcal", "ossa", "peugeot", "pgo", "piaggio", "polaris", "polini", "praga", "puch", "qj", "quadzilla", "quingoi", "rieju", "royal-enfield", "sachs", "sanglas", "scorpa", "sherco", "siamoto", "simson", "skyteam", "smc", "stark", "suzuki", "swm", "sym", "tgb", "tm", "tomos", "triumph", "trs", "valenti", "vent", "vertemati", "vertigo", "vespa", "victory", "villa", "voge", "vor", "voxan", "wk", "wrm", "yamaha", "zero", "zontes", "zundapp"];
  // Placeholder makes from supplier data, not real brands: kept in the index, hidden from the lists.
  var HIDDEN_MAKES = ['generic', 'cinesi-generico', 'c'];
  function isShownMake(m) { return HIDDEN_MAKES.indexOf(m.slug) < 0; }
  function logoUrl(slug) { return BASE + 'logos/' + slug + '.webp?v=8'; }
  var cache = {};
  function get(path) {
    if (!cache[path]) cache[path] = fetch(BASE + path).then(function (r) { if (!r.ok) throw new Error(path); return r.json(); });
    return cache[path];
  }
  /* Garage = several bikes, one active. Stored in localStorage ("moto-garage"); for logged-in customers also on the
     garage Worker (POST /v2/garage, signed by the theme in #MotoGarageAuth) so it follows them across devices.
     load() returns the active bike, so the verdict, results and picker work on that one. */
  var GKEY = 'moto-garage', API = BASE.replace(/v1\/$/, 'v2/');
  function bikeId(b) { return b.slug + '|' + b.model + '|' + b.year + '|' + (b.version || ''); }
  function readGarage() {
    var g = null;
    try { g = JSON.parse(localStorage.getItem(GKEY) || 'null'); } catch (e) {}
    if (!g || !Array.isArray(g.bikes)) {
      g = { bikes: [], active: null, updated: 0 };
      try { // one-time move of the single bike saved before garages existed
        var old = JSON.parse(localStorage.getItem(KEY) || 'null');
        if (old && old.slug) { old.id = bikeId(old); old.added = Date.now(); g.bikes.push(old); g.active = old.id; g.updated = Date.now(); writeGarage(g); }
        localStorage.removeItem(KEY);
      } catch (e) {}
    }
    return g;
  }
  function writeGarage(g) { try { localStorage.setItem(GKEY, JSON.stringify(g)); } catch (e) {} }
  function bikes() { return readGarage().bikes; }
  function load() {
    var g = readGarage();
    return g.bikes.filter(function (b) { return b.id === g.active; })[0] || g.bikes[0] || null;
  }
  function changed(g, push) {
    g.updated = Date.now(); writeGarage(g);
    if (push !== false) pushGarage(g);
    document.dispatchEvent(new CustomEvent('moto-garage:change', { detail: load() }));
  }
  /* save(bike): add it (or reuse the same bike already saved) and make it active. save(null): remove the active bike. */
  function save(b) {
    var g = readGarage();
    if (!b) { g.bikes = g.bikes.filter(function (x) { return x.id !== g.active; }); g.active = g.bikes[0] ? g.bikes[0].id : null; changed(g); return; }
    var id = bikeId(b), had = g.bikes.some(function (x) { return x.id === id; });
    if (!had) { b.id = id; b.added = Date.now(); g.bikes.unshift(b); g.bikes = g.bikes.slice(0, 10); countAdd(b); }
    g.active = id; changed(g);
  }
  function setActive(id) { var g = readGarage(); if (g.bikes.some(function (x) { return x.id === id; })) { g.active = id; changed(g); } }
  function remove(id) {
    var g = readGarage(); g.bikes = g.bikes.filter(function (x) { return x.id !== id; });
    if (g.active === id) g.active = g.bikes[0] ? g.bikes[0].id : null;
    changed(g);
  }
  // text/plain keeps these simple requests (no CORS preflight); keepalive lets them finish while the page navigates.
  function post(path, body) { return fetch(API + path, { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify(body), keepalive: true }); }
  function countAdd(b) { try { post('add', { slug: b.slug, label: b.label, model: b.model, year: b.year }).catch(function () {}); } catch (e) {} }
  var auth;
  function getAuth() {
    if (auth === undefined) { try { auth = JSON.parse(document.getElementById('MotoGarageAuth').textContent); } catch (e) { auth = null; } }
    return auth;
  }
  function pushGarage(g) { if (getAuth()) try { post('garage', { auth: auth, garage: g }).catch(function () {}); } catch (e) {} }
  /* On a page view by a logged-in customer: merge this device's bikes with the account's; the newer active choice wins. */
  function syncGarage() {
    if (!getAuth()) return;
    post('garage', { auth: auth }).then(function (r) { return r.ok ? r.json() : null; }).then(function (d) {
      if (!d) return;
      var local = readGarage(), remote = d.garage || { bikes: [], active: null, updated: 0 };
      var seen = {}, all = [];
      remote.bikes.concat(local.bikes).forEach(function (b) { if (b && b.id && !seen[b.id]) { seen[b.id] = 1; all.push(b); } });
      var active = (local.updated >= (remote.updated || 0) ? local.active : remote.active) || local.active || remote.active;
      var merged = { bikes: all.slice(0, 10), active: seen[active] ? active : (all[0] ? all[0].id : null), updated: Math.max(local.updated || 0, remote.updated || 0) };
      var sig = function (g) { return JSON.stringify([g.bikes.map(function (b) { return b.id; }).sort(), g.active]); };
      if (sig(merged) !== sig(remote)) pushGarage(merged);
      if (sig(merged) !== sig(local)) { writeGarage(merged); document.dispatchEvent(new CustomEvent('moto-garage:change', { detail: load() })); }
    }).catch(function () {});
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function label(b) { return b ? b.label + ' ' + b.model + (b.year && b.year !== '*' ? ' ' + b.year : '') + (b.version && b.version !== b.model ? ' (' + b.version + ')' : '') : ''; }
  function money(cents) { return '€' + (cents / 100).toFixed(2).replace('.', ','); }

  /* Customer-visible strings come from locale keys moto.garage.* via <script type="application/json" id="MotoGarageI18n">
     (snippets/header-actions.liquid). The Italian below is only a fallback if that element is missing.
     Shopify's t filter HTML-escapes keys not ending in _html, so those are decoded back to plain text here.
     {{ name }} tokens are filled by fmt(); plurals use <key>_one / <key>_other. */
  var I18N = {
    title: 'La tua moto', my_garage: 'Il mio garage', back: 'Indietro', close: 'Chiudi',
    search_make: 'Cerca la marca', search_model: 'Cerca il modello, es. SH 125',
    loading: 'Caricamento…', loading_models: 'Caricamento modelli…',
    top_makes: 'Marche più scelte', all_makes: 'Tutte le marche',
    parts_count_one: '{{ count }} ricambio', parts_count_other: '{{ count }} ricambi',
    no_make: 'Nessuna marca trovata.', all_years: 'Tutti gli anni',
    no_model: 'Nessun modello trovato. Prova solo con la cilindrata, es. 125.',
    reg_year: 'Anno di immatricolazione',
    version_note: 'Per questo anno i ricambi cambiano in base alla versione (es. ABS, iniezione). La trovi sul libretto.',
    change_bike: 'Cambia moto', change_bike_lower: 'cambia moto', save_bike: 'Salva la mia moto', remove_bike: 'Rimuovi la moto salvata',
    done_hint: 'Ti mostriamo solo i ricambi che il fornitore indica per la {{ bike }}.',
    trigger_bike: 'La tua moto: {{ bike }}. Cambia moto', trigger_empty: 'Il mio garage: aggiungi la tua moto',
    verdict_ask: 'Vuoi sapere se va bene sulla tua moto?', verdict_ok: 'Compatibile con la tua {{ bike }}',
    verdict_universal_html: '<strong>Ricambio universale</strong>: non è legato a un modello specifico. Verifica misure e attacchi.',
    verdict_no: 'Non risulta compatibile con la tua {{ bike }}.', see_parts: 'Vedi i ricambi per la tua moto',
    verdict_unknown: 'Per questo ricambio il fornitore non indica i modelli.', ask_fit: 'Chiedici se va bene sulla tua {{ bike }}',
    page_intro: 'Marca, modello e anno: ti mostriamo i ricambi compatibili.', choose_bike: 'Scegli la tua moto',
    in_stock: 'Disponibile', sold_out: 'Esaurito', chip_all: 'Tutti ({{ count }})',
    status_loading: 'Cerco i ricambi compatibili…',
    status_none_html: 'Non abbiamo ancora ricambi indicati per questa moto. <a href="' + ROOT + 'pages/contatti">Scrivici</a>: verifichiamo noi.',
    status_found: '{{ compatible }}, {{ available }}',
    compatible_count_one: '{{ count }} ricambio compatibile', compatible_count_other: '{{ count }} ricambi compatibili',
    available_count_one: '{{ count }} disponibile', available_count_other: '{{ count }} disponibili',
    status_error: 'Impossibile caricare i ricambi. Riprova tra poco.',
    models_count_one: '{{ count }} modello', models_count_other: '{{ count }} modelli',
    found_none: 'Nessun modello trovato. Prova solo la marca o il modello (es. "SH 125").',
    add_bike: 'Aggiungi la tua moto',
    your_bikes: 'Le tue moto', my_bikes: 'Le mie moto', in_use: 'In uso', use_bike: 'Usa questa moto', use_this: 'Usa',
    add_another: "Aggiungi un'altra moto", remove_named: 'Rimuovi {{ bike }}',
    account_saved: 'Salvate nel tuo account: le ritrovi su ogni dispositivo.',
    account_login_html: '<a href="{{ link }}">Accedi</a> per ritrovare le tue moto su ogni dispositivo.',
    for_bike_title: 'Per la tua {{ bike }}', for_bike_all: 'Vedi tutti i ricambi compatibili',
    for_bike_prompt: 'Aggiungi la tua moto: ti mostriamo i ricambi compatibili.',
    fit_badge: 'Compatibile con la tua moto',
    fit_banner_one: '{{ count }} ricambio di questa pagina è compatibile con la tua {{ bike }}.',
    fit_banner_other: '{{ count }} ricambi di questa pagina sono compatibili con la tua {{ bike }}.',
    fit_banner_none: 'In questa pagina non ci sono ricambi indicati per la tua {{ bike }}.',
    login_url: '/account/login'
  };
  var i18nRead = false;
  function fmt(s, v) { return String(s).replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, k) { return v && Object.prototype.hasOwnProperty.call(v, k) ? v[k] : m; }); }
  function t(k, v) {
    if (!i18nRead) {
      i18nRead = true;
      try {
        var el = document.getElementById('MotoGarageI18n'), j = el ? JSON.parse(el.textContent) : {};
        var ta = document.createElement('textarea');
        Object.keys(j).forEach(function (x) {
          if (typeof j[x] !== 'string' || !j[x]) return;
          if (/_html$/.test(x)) { I18N[x] = j[x]; return; }
          ta.innerHTML = j[x]; I18N[x] = ta.value;
        });
      } catch (e) {}
    }
    return fmt(I18N[k] == null ? '' : I18N[k], v);
  }
  function tn(k, n, v) { var o = { count: n }; if (v) Object.keys(v).forEach(function (x) { o[x] = v[x]; }); return t(k + (n === 1 ? '_one' : '_other'), o); }

  /* ids of parts that fit bike b (Set of numeric id strings) */
  function fitIds(b) {
    return get('fit/' + b.slug + '.json').then(function (fit) {
      var m = fit.models[b.model] || {}, out = new Set();
      [m[String(b.year)], m['*']].forEach(function (bk) {
        if (!bk) return;
        (bk.p || []).concat(bk.t || []).forEach(function (id) { out.add(String(id)); });
        if (b.version && bk.v && bk.v[b.version]) bk.v[b.version].forEach(function (id) { out.add(String(id)); });
      });
      return out;
    });
  }

  /* ---------- picker dialog: one step at a time (marca, modello, anno, versione), searchable list,
     choices kept as a trail of chips at the top; a chip takes you back to that step. ---------- */
  var dlg, st, makes = [];
  var ICON_X = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var ICON_BACK = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 6l-6 6 6 6"/></svg>';
  var ICON_NEXT = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>';
  var ICON_SEARCH = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6.5"/><path d="m20 20-4.8-4.8"/></svg>';
  function placeholder(step) { return step === 'make' ? t('search_make') : step === 'model' ? t('search_model') : ''; }
  function avatar(m, big) {
    var has = LOGOS.indexOf(m.slug) >= 0;
    return '<span class="mg-avatar' + (big ? ' mg-avatar--big' : '') + (has ? ' has-logo' : '') + '">' + (has
      ? '<img src="' + logoUrl(m.slug) + '" alt="" loading="lazy">'
      : '<span>' + esc(m.label.charAt(0)) + '</span>') + '</span>';
  }
  function norm(s) { return String(s).toLowerCase().replace(/[^a-z0-9]+/g, ''); }
  function sortModels(t) { return Object.keys(t.models).sort(function (a, b) { return a.localeCompare(b, 'it', { numeric: true }); }); }
  function yearsOf(m) { return (m.y || []).slice().sort(function (a, b) { return b - a; }); }
  function versionsOf(m, y) { return (m && m.vy && m.vy[y]) || []; }
  function row(attrs, lead, name, meta) {
    return '<li><button type="button" class="mg-row" ' + attrs + '>' + lead + '<span class="mg-row__name">' + name + '</span>' +
      (meta ? '<span class="mg-row__meta">' + meta + '</span>' : '') + ICON_NEXT + '</button></li>';
  }
  function buildDialog() {
    dlg = document.createElement('dialog');
    dlg.className = 'moto-garage-dialog';
    dlg.setAttribute('aria-labelledby', 'moto-garage-title');
    dlg.innerHTML =
      '<div class="mg">' +
      '<div class="mg__head"><button type="button" class="mg__icon" data-g-back aria-label="' + esc(t('back')) + '" hidden>' + ICON_BACK + '</button>' +
      '<h2 id="moto-garage-title" class="mg__title" tabindex="-1" autofocus>' + esc(t('title')) + '</h2>' +
      '<button type="button" class="mg__icon" data-g-close aria-label="' + esc(t('close')) + '">' + ICON_X + '</button></div>' +
      '<div class="mg__trail" data-g-trail></div>' +
      '<label class="mg__search" data-g-search>' + ICON_SEARCH + '<input type="search" data-g-q autocomplete="off" enterkeyhint="search"></label>' +
      '<div class="mg__body" data-g-body></div>' +
      '</div>';
    document.body.appendChild(dlg);
    var q = dlg.querySelector('[data-g-q]');
    q.addEventListener('input', renderBody);
    q.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      e.preventDefault();
      var first = dlg.querySelector('[data-g-body] .mg-row, [data-g-body] .mg-tile');
      if (first) first.click();
    });
    dlg.querySelector('[data-g-close]').addEventListener('click', function () { dlg.close(); });
    dlg.querySelector('[data-g-back]').addEventListener('click', function () {
      var order = ['make', 'model', 'year', 'version'], i = order.indexOf(st.step === 'done' ? backFromDone() : st.step);
      go(order[Math.max(0, i - 1)]);
    });
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg) { dlg.close(); return; }
      var el = e.target.closest('[data-pick-saved]');
      if (el) { setActive(el.dataset.pickSaved); dlg.close(); return; }
      el = e.target.closest('[data-pick-make]');
      if (el) { pickMake(el.dataset.pickMake); return; }
      el = e.target.closest('[data-pick-model]');
      if (el) { pickModel(el.dataset.pickModel); return; }
      el = e.target.closest('[data-pick-year]');
      if (el) { pickYear(el.dataset.pickYear); return; }
      el = e.target.closest('[data-pick-version]');
      if (el) { st.version = el.dataset.pickVersion; go('done'); return; }
      el = e.target.closest('[data-g-step]');
      if (el) { go(el.dataset.gStep); return; }
      if (e.target.closest('[data-g-save]')) {
        var b = bike(); if (!b) return; save(b); dlg.close();
        if (!document.querySelector('[data-moto-garage-page]')) location.href = ROOT + 'pages/il-mio-garage';
        return;
      }
      if (e.target.closest('[data-g-remove]')) { var r = bike(); if (r) remove(bikeId(r)); dlg.close(); }
    });
  }
  function backFromDone() {
    var m = st.tree && st.tree.models[st.model];
    if (versionsOf(m, st.year).length > 1) return 'version';
    return yearsOf(m || {}).length ? 'year' : 'model';
  }
  function bike() {
    if (!st.make || !st.model || !st.year) return null;
    return { slug: st.make.slug, make: st.make.make, label: st.make.label, model: st.model, year: st.year, version: st.version || null };
  }
  function go(step) {
    // Going back to a step clears that choice and the ones after it.
    var order = ['make', 'model', 'year', 'version'], i = order.indexOf(step);
    if (i >= 0) {
      if (i <= 0) { st.make = null; st.tree = null; }
      if (i <= 1) st.model = null;
      if (i <= 2) st.year = null;
      st.version = null;
    }
    st.step = step;
    var q = dlg.querySelector('[data-g-q]');
    q.value = '';
    render();
    if (placeholder(step) && window.matchMedia('(hover: hover)').matches) q.focus();
  }
  function pickMake(slug) {
    var m = makes.find(function (x) { return x.slug === slug; });
    if (!m) return;
    st.make = m; st.tree = null; st.step = 'model'; st.model = null; st.year = null; st.version = null;
    dlg.querySelector('[data-g-q]').value = '';
    render();
    return get('tree/' + slug + '.json').then(function (t) {
      if (st.make !== m) return;
      st.tree = t; render();
      if (window.matchMedia('(hover: hover)').matches) dlg.querySelector('[data-g-q]').focus();
    });
  }
  function pickModel(name) {
    var m = st.tree && st.tree.models[name];
    if (!m) return;
    st.model = name; st.version = null;
    var ys = yearsOf(m);
    if (!ys.length) { pickYear('*'); return; }
    if (ys.length === 1) { pickYear(String(ys[0])); return; }
    go('year');
  }
  function pickYear(y) {
    st.year = y;
    var vs = versionsOf(st.tree.models[st.model], y);
    // A version step only when the year really has more than one; a single version is chosen silently.
    if (vs.length > 1) { st.version = null; st.step = 'version'; render(); return; }
    st.version = vs.length === 1 ? vs[0] : null;
    st.step = 'done'; render();
  }
  function renderTrail() {
    var t = dlg.querySelector('[data-g-trail]'), parts = [];
    if (st.make) parts.push('<button type="button" class="mg-chip" data-g-step="make">' + avatar(st.make) + esc(st.make.label) + '</button>');
    if (st.model) parts.push('<button type="button" class="mg-chip" data-g-step="model">' + esc(st.model) + '</button>');
    if (st.year && st.year !== '*') parts.push('<button type="button" class="mg-chip" data-g-step="year">' + esc(st.year) + '</button>');
    if (st.version && st.version !== st.model && st.step === 'done' && versionsOf(st.tree.models[st.model], st.year).length > 1)
      parts.push('<button type="button" class="mg-chip" data-g-step="version">' + esc(st.version) + '</button>');
    t.innerHTML = parts.join('');
    t.hidden = !parts.length || st.step === 'done';
  }
  function render() {
    dlg.querySelector('[data-g-back]').hidden = st.step === 'make';
    var search = dlg.querySelector('[data-g-search]');
    search.hidden = !placeholder(st.step);
    dlg.querySelector('[data-g-q]').placeholder = placeholder(st.step);
    renderTrail();
    renderBody();
  }
  function renderBody() {
    var body = dlg.querySelector('[data-g-body]'), q = norm(dlg.querySelector('[data-g-q]').value), html = '';
    if (st.step === 'make') {
      if (!makes.length) { body.innerHTML = '<p class="mg-empty">' + esc(t('loading')) + '</p>'; return; }
      var mine = bikes(), act = load();
      if (!q && mine.length) {
        html += '<p class="mg-label">' + esc(t('your_bikes')) + '</p><ul class="mg-list mg-list--mine">' + mine.map(function (b) {
          var mk = makes.find(function (x) { return x.slug === b.slug; }) || { slug: b.slug, label: b.label };
          return row('data-pick-saved="' + esc(b.id) + '"', avatar(mk), esc(label(b)), act && act.id === b.id ? esc(t('in_use')) : '');
        }).join('') + '</ul>';
      }
      if (!q) {
        html += '<p class="mg-label">' + esc(t('top_makes')) + '</p><div class="mg-tiles">' + makes.slice(0, 8).map(function (m) {
          return '<button type="button" class="mg-tile" data-pick-make="' + esc(m.slug) + '">' + avatar(m, true) + '<span>' + esc(m.label) + '</span></button>';
        }).join('') + '</div><p class="mg-label">' + esc(t('all_makes')) + '</p>';
      }
      var list = makes.slice().sort(function (a, b) { return a.label.localeCompare(b.label, 'it'); })
        .filter(function (m) { return !q || norm(m.label).indexOf(q) >= 0; });
      html += list.length ? '<ul class="mg-list">' + list.map(function (m) {
        return row('data-pick-make="' + esc(m.slug) + '"', avatar(m), esc(m.label), esc(tn('parts_count', m.products)));
      }).join('') + '</ul>' : '<p class="mg-empty">' + esc(t('no_make')) + '</p>';
    } else if (st.step === 'model') {
      if (!st.tree) { body.innerHTML = '<p class="mg-empty">' + esc(t('loading_models')) + '</p>'; return; }
      var ms = sortModels(st.tree).filter(function (k) { return !q || norm(k).indexOf(q) >= 0; });
      html = ms.length ? '<ul class="mg-list">' + ms.map(function (k) {
        var ys = yearsOf(st.tree.models[k]);
        var range = ys.length ? (ys.length === 1 ? ys[0] : ys[ys.length - 1] + '–' + ys[0]) : esc(t('all_years'));
        return row('data-pick-model="' + esc(k) + '"', '', esc(k), range);
      }).join('') + '</ul>' : '<p class="mg-empty">' + esc(t('no_model')) + '</p>';
    } else if (st.step === 'year') {
      html = '<p class="mg-label">' + esc(t('reg_year')) + '</p><div class="mg-years">' + yearsOf(st.tree.models[st.model]).map(function (y) {
        return '<button type="button" class="mg-year" data-pick-year="' + y + '">' + y + '</button>';
      }).join('') + '</div>';
    } else if (st.step === 'version') {
      html = '<p class="mg-note">' + esc(t('version_note')) + '</p>' +
        '<ul class="mg-list">' + versionsOf(st.tree.models[st.model], st.year).map(function (v) {
          return row('data-pick-version="' + esc(v) + '"', '', esc(v), '');
        }).join('') + '</ul>';
    } else if (st.step === 'done') {
      var b = bike(), saved = b && bikes().some(function (x) { return x.id === bikeId(b); });
      html = '<div class="mg-done">' + avatar(st.make, true) +
        '<p class="mg-done__make">' + esc(st.make.label) + '</p>' +
        '<p class="mg-done__model">' + esc(st.model) + (st.year !== '*' ? ' <span>' + esc(st.year) + '</span>' : '') + '</p>' +
        (st.version && st.version !== st.model ? '<p class="mg-done__version">' + esc(st.version) + '</p>' : '') +
        '<button type="button" class="mg-done__change" data-g-step="make">' + esc(t('change_bike')) + '</button></div>' +
        '<div class="mg-actions"><button type="button" class="button mg-save" data-g-save>' + esc(t(saved ? 'use_bike' : 'save_bike')) + '</button>' +
        (saved ? '<button type="button" class="mg-remove" data-g-remove>' + esc(t('remove_bike')) + '</button>' : '') + '</div>' +
        '<p class="mg-hint">' + esc(t('done_hint', { bike: label(b) })) + '</p>';
    }
    body.innerHTML = html;
    body.scrollTop = 0;
  }
  function open(pre) {
    if (!dlg) buildDialog();
    st = { step: 'make', make: null, tree: null, model: null, year: null, version: null };
    render();
    if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
    get('makes.json').then(function (d) {
      makes = d.makes.filter(isShownMake);
      var start = pre && pre.slug ? pre : null;
      if (!start) { render(); if (window.matchMedia('(hover: hover)').matches) dlg.querySelector('[data-g-q]').focus(); return; }
      var p = pickMake(start.slug);
      if (p && start.model) p.then(function () {
        if (!st.tree || !st.tree.models[start.model]) return;
        st.model = start.model;
        if (start.year && yearsOf(st.tree.models[start.model]).map(String).indexOf(String(start.year)) >= 0) pickYear(String(start.year));
        else pickModel(start.model);
      });
    });
  }

  /* ---------- triggers (header button, drawer button) ---------- */
  function paintTriggers() {
    var b = load();
    document.querySelectorAll('[data-moto-garage-open]').forEach(function (el) {
      el.hidden = false;
      var l = el.querySelector('[data-moto-garage-label]');
      var text = b ? b.label + ' ' + b.model + (b.year && b.year !== '*' ? ' ' + b.year : '') : (el.dataset.motoGarageEmpty || t('my_garage'));
      if (l) l.textContent = text;
      el.classList.toggle('has-bike', !!b);
      el.setAttribute('aria-label', b ? t('trigger_bike', { bike: label(b) }) : t('trigger_empty'));
    });
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-moto-garage-open]');
    if (!t) return;
    e.preventDefault();
    if (t.matches('[data-moto-garage-goto]') && load()) { location.href = ROOT + 'pages/il-mio-garage'; return; }
    open();
  });
  document.addEventListener('moto-garage:change', paintTriggers);

  /* ---------- product page verdict ---------- */
  /* Product page box (owner 2026-10-17): only good news. It checks every bike in the garage and says "Compatibile con
     la tua <bike>" when the part fits one of them; otherwise it stays empty (no "not compatible", no universal/unknown
     notes), because fitment data is still thin for many makes. Without a saved bike it invites to add one. */
  function verdict() {
    var box = document.querySelector('[data-moto-garage-verdict]');
    if (!box) return;
    var pid = box.dataset.productId, all = bikes(), token = (box._token = {});
    box.className = 'moto-garage-verdict'; box.innerHTML = '';
    if (!all.length) {
      box.className = 'moto-garage-verdict is-empty';
      box.innerHTML = '<span>' + esc(t('verdict_ask')) + ' </span><button type="button" class="moto-garage-link" data-moto-garage-open>' + esc(t('add_bike')) + '</button>';
      return;
    }
    var act = load();
    // Active bike first, so it is the one named when several fit.
    all = all.slice().sort(function (a, b) { return (b.id === (act && act.id)) - (a.id === (act && act.id)); });
    Promise.all(all.map(function (b) { return fitIds(b).catch(function () { return new Set(); }); })).then(function (sets) {
      if (box._token !== token) return;
      for (var i = 0; i < all.length; i++) {
        if (!sets[i].has(pid)) continue;
        box.className = 'moto-garage-verdict is-ok';
        box.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12l5 5l10-10"/></svg><span><strong>' + esc(t('verdict_ok', { bike: label(all[i]) })) + '</strong></span>';
        return;
      }
    });
  }
  document.addEventListener('moto-garage:change', verdict);

  /* ---------- product cards from /products/<handle>.js (garage page, "Per la tua moto" row) ---------- */
  function card(p) {
    var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > 0 ? '&' : '?') + 'width=400' : '';
    var cmp = p.compare_at_price && p.compare_at_price > p.price ? '<s>' + money(p.compare_at_price) + '</s>' : '';
    return '<a class="moto-garage-card" href="' + esc(p.url) + '">' +
      '<span class="moto-garage-card__img">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy" width="400" height="400">' : '') + '</span>' +
      '<span class="moto-garage-card__vendor">' + esc(p.vendor) + '</span>' +
      '<span class="moto-garage-card__title">' + esc(p.title) + '</span>' +
      '<span class="moto-garage-card__price">' + money(p.price) + ' ' + cmp + '</span>' +
      '<span class="moto-garage-card__stock ' + (p.available ? 'is-in' : 'is-out') + '">' + esc(p.available ? t('in_stock') : t('sold_out')) + '</span></a>';
  }
  function fetchAll(hs) {
    var out = [], i = 0;
    function worker() {
      if (i >= hs.length) return Promise.resolve();
      var h = hs[i++];
      return fetch(ROOT + 'products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) { if (p) out.push(p); }).catch(function () {}).then(worker);
    }
    var ws = []; for (var k = 0; k < 8; k++) ws.push(worker());
    return Promise.all(ws).then(function () { return out; });
  }

  /* ---------- "Per la tua moto" row (sections/moto-for-your-bike.liquid): in-stock parts for the active bike,
     mixed across part types, a different pick on each visit. Without a bike: a prompt, or nothing (data-empty="hide"). ---------- */
  function forBike() {
    document.querySelectorAll('[data-moto-for-bike]').forEach(function (box) {
      var b = load(), head = box.querySelector('[data-fb-title]'), row = box.querySelector('[data-fb-row]'), all = box.querySelector('[data-fb-all]');
      var limit = Number(box.dataset.limit) || 8, token = (box._token = {});
      if (!b) {
        box.hidden = box.dataset.empty === 'hide';
        head.textContent = t('add_bike'); row.innerHTML = '<p class="moto-for-bike__prompt">' + esc(t('for_bike_prompt')) + ' <button type="button" class="button" data-moto-garage-open>' + esc(t('choose_bike')) + '</button></p>';
        all.hidden = true; return;
      }
      head.textContent = t('for_bike_title', { bike: label(b) });
      all.hidden = false; all.textContent = t('for_bike_all'); all.href = ROOT + 'pages/il-mio-garage';
      var inCart = box.dataset.excludeCart === 'true' ? fetch(ROOT + 'cart.js').then(function (r) { return r.json(); }).then(function (c) { return c.items.map(function (i) { return String(i.product_id); }); }).catch(function () { return []; }) : Promise.resolve([]);
      Promise.all([fitIds(b), get('handles.json'), inCart]).then(function (r) {
        var map = r[1], skip = r[2];
        var ids = Array.from(r[0]).filter(function (id) { return map[id] && skip.indexOf(id) < 0; });
        for (var i = ids.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)), x = ids[i]; ids[i] = ids[j]; ids[j] = x; }
        return fetchAll(ids.slice(0, limit * 4).map(function (id) { return map[id]; }));
      }).then(function (ps) {
        if (box._token !== token) return;
        // One of each part type first, then fill up: avoids a row of eight brake pads.
        var avail = ps.filter(function (p) { return p.available; }), byType = {}, pick = [];
        avail.forEach(function (p) { (byType[p.type || ''] = byType[p.type || ''] || []).push(p); });
        var lists = Object.keys(byType).map(function (k) { return byType[k]; });
        while (pick.length < limit && lists.some(function (l) { return l.length; })) lists.forEach(function (l) { if (l.length && pick.length < limit) pick.push(l.shift()); });
        box.hidden = !pick.length;
        row.innerHTML = pick.map(card).join('');
      }).catch(function () { box.hidden = true; });
    });
  }
  document.addEventListener('moto-garage:change', forBike);

  /* ---------- collection and search grids: badge on parts that fit the active bike, and those parts first within
     each loaded page (only with the default order: a sort chosen by the shopper is left alone). ---------- */
  /* Off by owner decision 2026-10-17: fitment data is still thin for many makes (e.g. Kawasaki), so collection and
     search pages are not badged or reordered by the saved bike. Parts for the bike show only on the garage page,
     when the visitor opens it. Set to true to turn it back on. */
  var GRID_FIT = false;
  function gridFit() {
    if (!GRID_FIT) return;
    var grids = document.querySelectorAll('.product-grid');
    if (!grids.length) return;
    document.querySelectorAll('.moto-fit-badge, .moto-fit-banner').forEach(function (el) { el.remove(); });
    var b = load();
    if (!b) return;
    var sorted = new URLSearchParams(location.search).has('sort_by');
    fitIds(b).then(function (ids) {
      grids.forEach(function (grid) {
        var items = Array.prototype.slice.call(grid.querySelectorAll(':scope > .product-grid__item[data-product-id]')), n = 0;
        items.forEach(function (li) {
          var fit = ids.has(li.dataset.productId);
          li.dataset.motoChecked = '1';
          li.classList.toggle('moto-fits', fit);
          if (!fit) return;
          n++;
          var cardEl = li.querySelector('.product-card__content') || li;
          cardEl.insertAdjacentHTML('beforeend', '<span class="moto-fit-badge"><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12l5 5l10-10"/></svg>' + esc(t('fit_badge')) + '</span>');
        });
        if (!sorted) {
          var pages = {};
          items.forEach(function (li) { (pages[li.dataset.page || '1'] = pages[li.dataset.page || '1'] || []).push(li); });
          Object.keys(pages).forEach(function (k) {
            var list = pages[k], anchor = list[0];
            list.filter(function (li) { return li.classList.contains('moto-fits'); }).forEach(function (li) { if (li !== anchor) grid.insertBefore(li, anchor); else anchor = li.nextElementSibling; });
          });
        }
        if (!n) return;
        var msg = tn('fit_banner', n, { bike: label(b) });
        grid.insertAdjacentHTML('beforebegin', '<p class="moto-fit-banner">' + esc(msg) + ' <a href="' + ROOT + 'pages/il-mio-garage">' + esc(t('for_bike_all')) + '</a></p>');
      });
    }).catch(function () {});
  }
  document.addEventListener('moto-garage:change', gridFit);

  /* ---------- garage page: results + archive ---------- */
  function page() {
    var root = document.querySelector('[data-moto-garage-page]');
    if (!root) return;
    var q = new URLSearchParams(location.search);
    var head = root.querySelector('[data-g-head]'), grid = root.querySelector('[data-g-grid]'), more = root.querySelector('[data-g-more]');
    var chips = root.querySelector('[data-g-chips]'), status = root.querySelector('[data-g-status]');
    var products = [], shown = 0, filter = q.get('type') || '', PAGE = 24, handles = null;
    function renderHead() {
      var b = load(), all = bikes();
      var note = getAuth() ? '<p class="moto-garage-page__account">' + esc(t('account_saved')) + '</p>'
        : '<p class="moto-garage-page__account">' + t('account_login_html', { link: esc(t('login_url')) }) + '</p>';
      head.innerHTML = b
        ? '<p class="moto-garage-page__eyebrow">' + esc(t('my_bikes')) + '</p>' +
          '<ul class="moto-bikes" role="list">' + all.map(function (x) {
            var on = x.id === b.id, mk = { slug: x.slug, label: x.label };
            return '<li class="moto-bike' + (on ? ' is-active' : '') + '">' + avatar(mk) +
              '<span class="moto-bike__name"><strong>' + esc(x.label) + '</strong> ' + esc(label(x).replace(x.label + ' ', '')) + '</span>' +
              (on ? '<span class="moto-bike__state">' + esc(t('in_use')) + '</span>'
                  : '<button type="button" class="moto-bike__use" data-g-use="' + esc(x.id) + '">' + esc(t('use_this')) + '</button>') +
              '<button type="button" class="moto-bike__remove" data-g-del="' + esc(x.id) + '" aria-label="' + esc(t('remove_named', { bike: label(x) })) + '">' + ICON_X + '</button></li>';
          }).join('') + '</ul>' +
          '<button type="button" class="button button-secondary moto-garage-page__add" data-moto-garage-open>' + esc(t('add_another')) + '</button>' + note
        : '<p class="moto-garage-page__eyebrow">' + esc(t('my_garage')) + '</p><h2 class="moto-garage-page__bike">' + esc(t('add_bike')) + '</h2><p>' + esc(t('page_intro')) + '</p><button type="button" class="button" data-moto-garage-open>' + esc(t('choose_bike')) + '</button>' + note;
    }
    head.addEventListener('click', function (e) {
      var u = e.target.closest('[data-g-use]'); if (u) { setActive(u.dataset.gUse); return; }
      var d = e.target.closest('[data-g-del]'); if (d) remove(d.dataset.gDel);
    });
    function visible() { return products.filter(function (p) { return !filter || p.type === filter; }); }
    function renderGrid(reset) {
      var list = visible();
      if (reset) { grid.innerHTML = ''; shown = 0; }
      var next = list.slice(shown, shown + PAGE);
      grid.insertAdjacentHTML('beforeend', next.map(card).join(''));
      shown += next.length;
      more.hidden = shown >= list.length;
    }
    function renderChips() {
      var counts = {};
      products.forEach(function (p) { if (p.type) counts[p.type] = (counts[p.type] || 0) + 1; });
      var types = Object.keys(counts).sort(function (a, b) { return counts[b] - counts[a]; }).slice(0, 14);
      if (filter && !counts[filter]) filter = '';
      chips.innerHTML = types.length > 1 ? '<button type="button" class="moto-chip' + (filter ? '' : ' is-on') + '" data-t="">' + esc(t('chip_all', { count: products.length })) + '</button>' +
        types.map(function (x) { return '<button type="button" class="moto-chip' + (x === filter ? ' is-on' : '') + '" data-t="' + esc(x) + '">' + esc(x) + ' (' + counts[x] + ')</button>'; }).join('') : '';
    }
    chips.addEventListener('click', function (e) {
      var c = e.target.closest('.moto-chip'); if (!c) return;
      filter = c.dataset.t; chips.querySelectorAll('.moto-chip').forEach(function (x) { x.classList.toggle('is-on', x === c); });
      renderGrid(true);
    });
    more.addEventListener('click', function () { renderGrid(false); });
    function results() {
      renderHead();
      var b = load();
      grid.innerHTML = ''; chips.innerHTML = ''; more.hidden = true; products = [];
      if (!b) { status.textContent = ''; return; }
      status.textContent = t('status_loading');
      Promise.all([fitIds(b), get('handles.json')]).then(function (r) {
        var ids = Array.from(r[0]), map = r[1];
        var hs = ids.map(function (id) { return map[id]; }).filter(Boolean);
        if (!hs.length) { status.innerHTML = t('status_none_html'); return; }
        return fetchAll(hs).then(function (ps) {
          products = ps.sort(function (a, b) { return (b.available - a.available) || a.title.localeCompare(b.title, 'it'); });
          var inStock = products.filter(function (p) { return p.available; }).length;
          status.textContent = t('status_found', { compatible: tn('compatible_count', products.length), available: tn('available_count', inStock) });
          renderChips(); renderGrid(true);
        });
      }).catch(function () { status.textContent = t('status_error'); });
    }
    document.addEventListener('moto-garage:change', results);
    // deep link: ?make=honda&model=SH%20125&year=2010
    if (q.get('make')) open({ slug: q.get('make'), model: q.get('model'), year: q.get('year') });
    results();

    /* archive */
    var mk = root.querySelector('[data-g-makes]'), search = root.querySelector('[data-g-search]'), found = root.querySelector('[data-g-found]');
    get('makes.json').then(function (d) {
      mk.innerHTML = d.makes.filter(isShownMake).slice(0, 24).map(function (m) {
        var logo = LOGOS.indexOf(m.slug) >= 0 ? '<img src="' + logoUrl(m.slug) + '" alt="" width="80" height="48" loading="lazy">' : '';
        return '<button type="button" class="moto-make' + (logo ? ' has-logo' : '') + '" data-slug="' + esc(m.slug) + '">' + logo + '<span class="moto-make__name">' + esc(m.label) + '</span><span class="moto-make__n">' + esc(tn('models_count', m.models)) + '</span></button>';
      }).join('');
    });
    mk.addEventListener('click', function (e) {
      var b = e.target.closest('.moto-make'); if (!b) return;
      search.value = b.querySelector('.moto-make__name').textContent + ' '; search.focus(); search.dispatchEvent(new Event('input'));
    });
    var rows = null;
    search.addEventListener('input', function () {
      var v = this.value.trim().toLowerCase();
      if (v.length < 2) { found.innerHTML = ''; return; }
      (rows || (rows = get('models.json'))).then(function (d) {
        var words = v.split(/\s+/), hits = [];
        for (var i = 0; i < d.rows.length && hits.length < 80; i++) {
          var r = d.rows[i], hay = (r[1] + ' ' + r[2]).toLowerCase();
          if (HIDDEN_MAKES.indexOf(r[0]) >= 0) continue;
          if (words.every(function (w) { return hay.indexOf(w) >= 0; })) hits.push(r);
        }
        found.innerHTML = hits.length ? hits.map(function (r) {
          var yrs = r[3] ? (r[3] === r[4] ? r[3] : r[3] + '–' + r[4]) : '';
          return '<li><button type="button" data-slug="' + esc(r[0]) + '" data-model="' + esc(r[2]) + '"><span><strong>' + esc(r[1]) + '</strong> ' + esc(r[2]) + '</span><span class="moto-found__meta">' + esc(yrs) + ' · ' + esc(tn('parts_count', r[5])) + '</span></button></li>';
        }).join('') : '<li class="moto-found__none">' + esc(t('found_none')) + '</li>';
      });
    });
    found.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-slug]'); if (!b) return;
      open({ slug: b.dataset.slug, model: b.dataset.model });
    });
  }

  function init() {
    paintTriggers(); verdict(); page(); forBike(); gridFit(); syncGarage();
    // Infinite scroll appends pages to the grid: badge and order the new cards too.
    document.querySelectorAll('.product-grid').forEach(function (g) {
      var timer;
      new MutationObserver(function () {
        if (!g.querySelector(':scope > .product-grid__item:not([data-moto-checked])')) return;
        clearTimeout(timer); timer = setTimeout(gridFit, 150);
      }).observe(g, { childList: true });
    });
    // Header/drawer markup can be (re)rendered after load (drawer, section updates): keep triggers painted.
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var n = muts[i].target;
        if (n.nodeType === 1 && (n.matches('[data-moto-garage-open][hidden]') || n.querySelector('[data-moto-garage-open][hidden]'))) { paintTriggers(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.MotoGarage = { open: open, get: load, bikes: bikes, setActive: setActive, remove: remove, fitIds: fitIds };
})();
